module.exports = __webpack_public_path__ + "static/media/Drink.97a83f84.pdf";